module.exports = __webpack_public_path__ + "img/en-ca.525653e4.svg";